module.exports = __webpack_public_path__ + "static/media/featureIconTwo.7be81569.webp";